import styled from 'styled-components';
import { customMedia } from 'styles/utils';

export const LargePanelSectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  padding: ${props =>
    props.first ? '2rem 3rem 1rem 3rem' : '2rem 3rem 0.5rem 3rem'};
`;

export const ContentBlockWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 2rem;

  ${customMedia.lessThan('medium')`
    grid-template-columns: repeat(1, 1fr);
  `};
`;

export const ContentBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: space-between;
  width: 100%;
  min-height: 3rem;

  h5 {
    min-height: 1.5rem;
  }

  ${customMedia.lessThan('medium')`
    display: ${props => (props.empty ? 'none' : 'flex')};
    min-height: ${props => (props.empty ? '0px' : '3rem')};
  `};
`;

export const OverflowWrapper = styled.div`
  overflow-y: auto;
`;

export const TitleRowWrapper = styled.div`
  display: flex;
  align-items: baseline;
`;
